// Generated by CoffeeScript 1.11.1
(function() {
  var Descriptor, LayerInfo, ObjectEffects,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  LayerInfo = require('../layer_info');

  Descriptor = require('../descriptor');

  module.exports = ObjectEffects = (function(superClass) {
    extend(ObjectEffects, superClass);

    function ObjectEffects() {
      return ObjectEffects.__super__.constructor.apply(this, arguments);
    }

    ObjectEffects.shouldParse = function(key) {
      return key === 'lfx2' || key === 'lmfx';
    };

    ObjectEffects.prototype.parse = function() {
      this.file.seek(8, true);
      return this.data = new Descriptor(this.file).parse();
    };

    return ObjectEffects;

  })(LayerInfo);

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer_info/object_effects.js
// module id = 70
// module chunks = 0